import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

const META = {
  contact: { label: "Contact messages", cols: ["name", "email", "subject", "message", "created_at"] },
  newsletter: { label: "Newsletter signups", cols: ["email", "created_at"] },
  featured: { label: "Featured applications", cols: ["full_name", "email", "company", "role", "country", "interest", "message", "created_at"] },
};

const AdminMessagesPage = () => {
  const { msgKind } = useParams();
  const meta = META[msgKind] || META.contact;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try { setItems(await api.adminMessages(msgKind)); }
      catch { setItems([]); }
      finally { setLoading(false); }
    })();
  }, [msgKind]);

  const filtered = q.trim()
    ? items.filter((x) => JSON.stringify(x).toLowerCase().includes(q.toLowerCase()))
    : items;

  return (
    <div data-testid={`admin-messages-${msgKind}`}>
      <div className="overline overline-muted mb-3">Inbox</div>
      <h1 className="font-display text-ink text-4xl md:text-5xl leading-[1.05] tracking-[-0.015em]">{meta.label}</h1>

      <div className="mt-8 flex items-center gap-3">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search…"
          data-testid="admin-messages-search"
          className="flex-1 px-4 py-2.5 bg-paper border border-ink-line rounded-full text-sm outline-none focus:border-ink"
        />
        <span className="text-xs text-ink-muted font-mono-editorial">{filtered.length} · {items.length} total</span>
      </div>

      <div className="mt-6 editorial-card overflow-x-auto">
        {loading ? (
          <div className="p-8 text-ink-soft text-sm">Loading…</div>
        ) : filtered.length === 0 ? (
          <div className="p-8 text-ink-soft text-sm">No messages yet.</div>
        ) : (
          <table className="w-full text-sm min-w-[700px]">
            <thead className="bg-cream text-left text-[11px] font-mono-editorial uppercase tracking-[0.16em] text-ink-muted">
              <tr>{meta.cols.map((c) => <th key={c} className="px-4 py-3 whitespace-nowrap">{c.replace(/_/g, " ")}</th>)}</tr>
            </thead>
            <tbody>
              {filtered.map((row) => (
                <tr key={row.id} className="border-t border-ink-line align-top">
                  {meta.cols.map((c) => (
                    <td key={c} className={`px-4 py-3 ${c === "message" ? "max-w-[420px]" : ""} ${c === "created_at" ? "text-ink-muted font-mono-editorial text-xs whitespace-nowrap" : "text-ink"}`}>
                      {c === "created_at" && row[c] ? new Date(row[c]).toLocaleString() : (row[c] || "—")}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminMessagesPage;
